<template lang="pug">
GenericCard.user-stat-panel(size='33')
  div(v-if='user' style='padding-bottom: 20px')
    .cover-img.d-flex.flex-column.justify-content-end(:style='`backgroundImage: url(${coverImg})`')
      .user-name.text-large.pb-2.pr-4
        | {{ user.firstName }}

    .user-img.ml-3
      UserPicture(
        :imgSrc='user.imgSrc'
        :badgeNumber='notificationCount'
        @click='showNotifications'
      )
    .user-detail.d-flex
      .text-medium.bold.mt-2
        | {{ role }}
    //- .text-small.mt-2
    //-   | {{ user }}

</template>

<script>
/* eslint-disable global-require */
export default {
  props: {
    user: {},
    notificationCount: {
      default: '...',
    },
    role: {
      default: 'Administrator',
    },
  },
  data: () => ({
    coverImg: require('@/assets/dashboard/header-background-user-stat.png'),
  }),
  methods: {
    showNotifications() {
      this.$modal.show('notification');
    },
  },
};
</script>

<style lang="scss" scoped>
$user-img-size: 72px;
$user-img-left-padding: $user-img-size + (16 * 2);

.user-stat-panel {
  position: relative;
  .cover-img {
    height: 80px;
    width: 100%;
    border-top-left-radius: $card-border-radius;
    border-top-right-radius: $card-border-radius;
    .user-name {
      margin-left: $user-img-left-padding;
      color: #fff;
    }
  }
  .user-img {
    height: $user-img-size;
    width: $user-img-size;
    margin-top: -($user-img-size * 0.6);
  }
  .user-detail {
    margin-top: -($user-img-size * 0.4);
    margin-left: $user-img-left-padding;
    font-size: 16px;
    min-height: ($user-img-size * 0.4);
  }
}
</style>
